import {
  type ActiveSessionState,
  type InactiveSessionState,
  type QueuedSessionState,
} from "@financeable/brokerloop-data-plane";
import { type AlertProps } from "@financeable-com-au/financeable-ui";

enum LodgeAIModalType {
  Queue = "queue",
  Automation = "automation",
  Error = "error",
}

type LodgeAIAutomation = (Omit<ActiveSessionState, "expiresAt"> | InactiveSessionState) & {
  isManualIntervention?: boolean;
  manualInterventionReason?: string;
  manualInterventionIntent?: AlertProps["intent"];
  isCompleted?: boolean;
  isClosed?: boolean;
  isErrored?: boolean;
};

interface LodgeAIQueue extends Pick<QueuedSessionState, "queuePosition"> {
  inProgress?: boolean;
}

interface LodgeAISession {
  sessionId?: string;
  isActive?: boolean;
  jwt?: string;
  expiresAt?: ActiveSessionState["expiresAt"];
  isExpiring?: boolean;
  lender?: string;
  traceId?: string;
}

interface LodgeAISlice {
  modalType?: LodgeAIModalType;
  isOpen?: boolean;
  automation?: LodgeAIAutomation;
  queue?: LodgeAIQueue;
  session?: LodgeAISession;
  error?: {
    title?: string;
    message?: string;
  };
}

export { LodgeAIModalType };
export type { LodgeAISlice, LodgeAIAutomation, LodgeAIQueue, LodgeAISession };
